import React from 'react';
import Logo from '../../images/Asset10.png';
import CallUs from '../../images/call-us-logo-removebg-preview.png';
import instgram from '../../images/insta-white.png';
import facebook from '../../images/fb-white.png';
import tiktok from '../../images/tiktok-white.png';
import youtube from '../../images/Youtube-white.png';
import linkedin from '../../images/in-white (2).png';
import snap from '../../images/snap-white.png';
import { useTranslation } from 'react-i18next';
import './footer.css';
import { Link } from 'react-router-dom';

const socials = [
  { href: 'https://www.facebook.com/learnovative.uk/', icon: facebook, label: 'Facebook' },
  { href: 'https://www.instagram.com/learnovative.uk/', icon: instgram, label: 'Instagram' },
  { href: 'https://www.tiktok.com/@learnovative.uk?lang=en', icon: tiktok, label: 'TikTok' },
  { href: 'https://www.youtube.com/@Learnovative-ok4dx', icon: youtube, label: 'YouTube' },
  { href: 'https://www.linkedin.com/company/learnovative-uk/?viewAsMember=true', icon: linkedin, label: 'LinkedIn' },
  { href: 'https://snapchat.com/t/JkI6Oqr8', icon: snap, label: 'Snapchat' },
];

const navLinks = [
  { to: '/about', key: 'About' },
  { to: '/contact', key: 'Contact Us' },
  { to: '/courses', key: 'Courses' },
  { to: '/instructors', key: 'Instructors' },
  { to: '/terms', key: 'Terms & Condition' },
];

function Footer() {
  const phoneNumber = '+971551026501';
  const { t } = useTranslation();

  return (
    <footer className="footer" aria-label="Site footer">
      <div className="footer-accent" aria-hidden="true" />

      <div className="container footer-main">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="footer-logo-link" aria-label="Learnovative home">
              <img className="footer-logo" src={Logo} alt="Learnovative" loading="lazy" />
            </Link>
            <p className="footer-tagline">
              {t('In todays globalized business environment, language learning has become a crucial element of professional development. As companies increasingly operate across borders')}
            </p>
            <div className="footer-socials">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  className="footer-social-link"
                  target="_blank"
                  rel="noreferrer"
                  aria-label={s.label}
                >
                  <img src={s.icon} alt="" loading="lazy" />
                </a>
              ))}
            </div>
          </div>

          <div className="footer-cta">
            <a href={`tel:${phoneNumber}`} className="footer-call-link" aria-label="Call Learnovative">
              <img className="footer-call-img" src={CallUs} alt="" loading="lazy" />
            </a>
          </div>
        </div>

        <div className="footer-divider" aria-hidden="true" />

        <div className="footer-bottom">
          <nav className="footer-nav" aria-label="Footer navigation">
            {navLinks.map((link, i) => (
              <React.Fragment key={link.key}>
                {i > 0 && (
                  <span className="footer-nav-dot" aria-hidden="true">·</span>
                )}
                <Link to={link.to} className="footer-nav-link">
                  {t(link.key)}
                </Link>
              </React.Fragment>
            ))}
          </nav>
          <p className="footer-copy">
            © {new Date().getFullYear()} Learnovative
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
